module.exports = __webpack_public_path__ + "img/violet_020.55c1b0d6.png";